import React, { useContext } from "react";
import styles from "./MoreServices.module.scss";
import { Context } from "../../Store";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import Loading from "../../Loading/Loading";
const Slider = () => {
  let { services2Res, dir, servicesRes2Loading } = useContext(Context);

  return (
    <>
      <Swiper
        dir={dir}
        slidesPerView={3}
        spaceBetween={40}
        slidesPerGroup={3}
        loop={true}
        loopFillGroupWithBlank={true}
        navigation={true}
        modules={[Navigation]}
        breakpoints={{
          0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          700: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          1000: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          1480: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
        }}
      >
        {servicesRes2Loading ? (
          <Loading />
        ) : (
          <>
            {services2Res?.map((service) => (
              <SwiperSlide key={service.id}>
                <div className={styles.item}>
                  <img src={service?.logo} alt="" />
                  <h3>{service?.name}</h3>
                  <span>{service?.desc}</span>
                </div>
              </SwiperSlide>
            ))}
          </>
        )}
      </Swiper>
    </>
  );
};

export default Slider;
